'use client'

import Link from 'next/link'
import { HEADER_FOLD } from '@/components/site/headerFold'
import { buttonClass } from '@/components/ui/Button'
import { useSessionSummary } from '@/lib/session/sessionSummary'
import LaunchCta from './LaunchCta'
import LandingNavMenu from './LandingNavMenu'

// The session-dependent half of the marketing header. It lives on the client
// so the header itself — and every page that renders it — stays static: a
// cookie read in a server component opts the whole route into per-request
// rendering. Until /api/auth/me answers it paints the signed-out bar, which is
// what nearly all traffic to these pages is.
//
// Right cluster: the account link (steps back as the pill draws in —
// site/headerFold.ts), then the one primary. Below `lg` the menu
// carries the links, Pricing and the account; below `sm` the account link
// lives only there.

export default function LandingNavAccount({ signedIn: forced }: { signedIn?: boolean }) {
  const session = useSessionSummary()
  const signedIn = forced ?? session.signedIn
  const unlimited = forced === undefined && session.isPro
  return (
    <div className="ml-auto flex shrink-0 items-center gap-2">
      <LandingNavMenu signedIn={signedIn} unlimited={unlimited} />
      <span className={`hidden max-w-[10rem] sm:inline-flex ${HEADER_FOLD}`}>
        <Link
          href={signedIn ? '/rooms' : '/login'}
          className={buttonClass({ variant: 'ghost', size: 'md', className: '!text-body' })}
        >
          {signedIn ? 'My rooms' : 'Sign in'}
        </Link>
      </span>
      <LaunchCta
        href="/room/new?start=build"
        location="nav"
        className={buttonClass({ variant: 'primary', size: 'md', className: '!text-body' })}
      >
        <span className="sm:hidden">Start</span>
        <span className="hidden sm:inline">Start building</span>
      </LaunchCta>
    </div>
  )
}
